export default "__VITE_ASSET__PSYLM_Y7__"